export default __webpack_public_path__ + "static/masyLogo-358f515dfb0cc98505ac0c8082fd7964.png";